import BlogCard from 'js/blog/components/Card'
import DiscussionCard from 'js/discussions/components/Card'
import EventCard from 'js/events/components/Card'
import GenericArticleCard from 'js/genericArticle/Card'
import StatusUpdateCard from 'js/group/StatusUpdate/Card'
import NewsCard from 'js/news/components/Card'
import PodcastCard from 'js/podcast/components/PodcastCard'
import QuestionCard from 'js/questions/components/Card'
import WikiCard from 'js/wiki/components/Card'

type Entity = {
    __typename: string
    [key: string]: any
}

type Props = {
    entity: Entity
    [key: string]: any
}

const Card = ({ entity, ...rest }: Props) => {
    switch (entity.__typename) {
        case 'Blog':
            return <BlogCard entity={entity} {...(rest as any)} />

        case 'Discussion':
            return <DiscussionCard entity={entity} {...(rest as any)} />

        case 'GenericArticle':
            return <GenericArticleCard entity={entity} {...(rest as any)} />

        case 'Event':
            return <EventCard entity={entity} {...(rest as any)} />

        case 'News':
            return <NewsCard entity={entity} {...(rest as any)} />

        case 'Podcast':
            return <PodcastCard entity={entity} {...(rest as any)} />

        case 'Question':
            return <QuestionCard entity={entity} {...(rest as any)} />

        case 'StatusUpdate':
            return <StatusUpdateCard entity={entity} {...(rest as any)} />

        case 'Wiki':
            return <WikiCard entity={entity} {...(rest as any)} />

        default:
            return null
    }
}

export default Card
